import * as React from "react";
import { FluentProvider, makeStyles, webLightTheme } from "@fluentui/react-components";
import { type FetchXmlBuilderTree, type IFetchXmlBuilderDataSource } from "@kodikas/fetchxml-builder";
import { DataverseLoginControl } from "./components/DataverseLoginControl";
import { FetchXmlBuilderControl } from "./components/FetchXmlBuilderControl";
import { createDataverseDataSource } from "./services/dataverse/dataSource";
import type { DataverseConnectionConfig } from "./services/dataverse/types";

const useStyles = makeStyles({
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #f6f8fb 0%, #ffffff 100%)",
    padding: "24px",
    display: "grid",
    gridTemplateRows: "160px auto",
    gap: "16px",
  },
});

export function App(): JSX.Element {
  const styles = useStyles();
  const [connection, setConnection] = React.useState<DataverseConnectionConfig | null>(null);
  const [currentTree, setCurrentTree] = React.useState<FetchXmlBuilderTree | null>(null);

  const dataSource = React.useMemo<IFetchXmlBuilderDataSource | null>(() => {
    if (!connection) {
      return null;
    }

    return createDataverseDataSource(connection);
  }, [connection]);

  return (
    <FluentProvider theme={webLightTheme}>
      <div className={styles.page}>
        <DataverseLoginControl
          connection={connection}
          onConnectionChange={setConnection}
          onDisconnected={() => setCurrentTree(null)}
        />

        <FetchXmlBuilderControl dataSource={dataSource} tree={currentTree} onTreeChange={setCurrentTree} />
      </div>
    </FluentProvider>
  );
}
